import React from "react";
import { Box } from "@mui/material";
import AssessmentOutlined from "@mui/icons-material/AssessmentOutlined";
import ShieldOutlined from "@mui/icons-material/ShieldOutlined";
import ReplayOutlined from "@mui/icons-material/ReplayOutlined";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import { StatCard } from "services/constants/designTokens";

const cards = [
  { key: "ALL", title: "All", icon: AssessmentOutlined, accent: "#2563EB", tint: "#EFF6FF" },
  { key: "Quarantined", title: "Quarantined", icon: ShieldOutlined, accent: "#7C3AED", tint: "#F5F3FF" },
  { key: "Retry", title: "Retry", icon: ReplayOutlined, accent: "#D97706", tint: "#FFFBEB" },
  { key: "Failed", title: "Failed", icon: ErrorOutline, accent: "#DC2626", tint: "#FEF2F2" },
];

export function EventTraceStatusCards({ counts, status, onSelect }) {
  return <Box role="group" aria-label="Event status summary" sx={{
    display: "grid",
    gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))" },
    gap: 1.5,
  }}>
    {cards.map(({ key, ...card }) => <StatCard key={key} {...card} activeBorder
      value={counts?.[key] ?? "—"} isActive={(status || "ALL") === key}
      onClick={() => onSelect(key === "ALL" || status === key ? null : key)} />)}
  </Box>;
}
